import { SxProps } from '@mui/material';

export const DpCardMapFrameSX: SxProps = {
	backgroundColor: '#FBFBFC',
};

export const DpCardMapGridSpacing = { xs: 3, md: 12 };

export const DpCardMapStyle = { height: '300px', width: '100%', alignSelf: 'center' };

export const DpCardMapInfoFrameSX: SxProps = {
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	alignItems: 'center',
	gap: '20px',
};

export const DpCardMapInfoTitleSX: SxProps = {
	textAlign: { xs: 'center', md: 'left' },
	fontSize: { xs: 'var(--font-size-md)', md: 'var(--font-size-xl)' },
};

export const DpCardMapInfoWindowNameSX: SxProps = {
	fontSize: { xs: 'var(--font-size-sm)', md: 'var(--font-size-md)' },
	fontWeight: 'bold',
};
